export default __webpack_public_path__ + "static/media/que.a70e1cfd.svg";